import { useT } from '@transifex/react'

export const debounce = (func: any, wait: number) => {
  let timeout: any
  return function (this: any, ...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    const later = function () {
      timeout = null
    }
    const callNow = !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export const throttle = (func: any, limit: number) => {
  let inThrottle: boolean
  return function (this: any, ...args: any[]) {
    if (!inThrottle) {
      func.apply(this, args)
      inThrottle = true
      setTimeout(() => {
        inThrottle = false
      }, limit)
    }
  }
}

// eslint-disable-next-line no-promise-executor-return
export const sleep = (ms = 200) => new Promise((resolve) => setTimeout(resolve, ms))

export const countryPhoneFormatMapping: { [x: string]: string } = {
  SE: 'ex. 0701234567',
  NO: 'eks. 41234567',
  FI: 'ex. 401234567',
  GB: 'e.g. 07700900418',
  DK: 'eks. 12345678',
  PL: 'np. 512345678',
  DE: 'z.B. 15123456789',
  FR: 'ex. 612345678',
  ES: 'ej. 612345678',
  PT: 'ex. 912345678',
  LT: 'pvz. 61234567',
}

export const getCompartmentInfo = (selectedDoor: Door) => {
  const t = useT()
  const dimensionValue = selectedDoor?.dimensions?.[0] || 0

  const sizeLabels: { [key: number]: string } = {
    90: t('x-small'),
    155: t('small'),
    332: t('medium'),
    509: t('large'),
  }
  const height = selectedDoor?.dimensions?.[0] || 0
  const width = selectedDoor?.dimensions?.[1] || 0
  const compartmentName = selectedDoor && selectedDoor.doorIdx !== undefined && selectedDoor.doorIdx !== null ? selectedDoor.doorIdx + 1 : ''
  const depth = selectedDoor?.dimensions?.[2] || 0
  const label = sizeLabels[dimensionValue]
  return { compartmentName, label, height, width, depth }
}

export const roundNumber = (num: string, decimals = 2) => parseFloat(num).toFixed(decimals)

export const formatDate = (timestamp: string) => {
  const date = new Date(timestamp)
  const day = date.getDate()
  const month = date.getMonth() + 1

  const hours = date.getHours()
  const minutes = date.getMinutes()
  const formattedDate = `${day}/${month} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`

  return formattedDate
}

export const objectIdToDate = (objectId: string | undefined) => {
  if (!objectId) return ''

  const timestampHex = objectId.substring(0, 8)

  const timestamp = parseInt(timestampHex, 16)

  return new Date(timestamp * 1000)
}
